import { Pipe, PipeTransform } from '@angular/core';
import { Area, HierarchyArea } from '@cue/data';

@Pipe({
  name: 'areaToHierarchy',
  standalone: true,
})
export class AreaToHierarchyPipe implements PipeTransform {
  transform(areasInfoData: Area[]): HierarchyArea[] {
    const areaToHierarchyAreaCrate: Record<number, HierarchyArea> = {};
    const result: HierarchyArea[] = [];

    areasInfoData
      .sort((a, b) => a.parentAreaId - b.parentAreaId)
      .forEach((area) => {
        areaToHierarchyAreaCrate[area.id] = { ...area, children: [] } as unknown as HierarchyArea;

        if (area.parentAreaId !== null && areaToHierarchyAreaCrate[area.parentAreaId]) {
          this.insertSorted(areaToHierarchyAreaCrate[area.id], areaToHierarchyAreaCrate[area.parentAreaId].children);
          // areaToHierarchyAreaCrate[area.parentAreaId].children.push(areaToHierarchyAreaCrate[area.id]);
          //
          // areaToHierarchyAreaCrate[area.parentAreaId].children = areaToHierarchyAreaCrate[area.parentAreaId].children.sort((a,b)=>a.rank - b.rank);
        } else {
          result.push(areaToHierarchyAreaCrate[area.id]);
        }
      });
    return this.transformRecursively(result, areaToHierarchyAreaCrate);
  }

  private insertSorted(item: HierarchyArea, childList: HierarchyArea[]): void {
    const index = childList.findIndex((existingItem) => existingItem.rank > item.rank);
    if (index === -1) {
      childList.push(item); // Item has the highest rank
    } else {
      childList.splice(index, 0, item);
    }
  }

  private transformRecursively(data: HierarchyArea[], areaToHierarchyAreaCrate: Record<number, HierarchyArea>): any {
    return data.map((area) => {
      if (area.children.length > 0) {
        area.children = this.transformRecursively(area.children, areaToHierarchyAreaCrate);
      }
      const { id, name, parentAreaId } = area;
      const parentArea = areaToHierarchyAreaCrate[parentAreaId] ? { ...areaToHierarchyAreaCrate[parentAreaId] } : null;
      return {
        id,
        name,
        parentAreaId,
        parentArea,
        children: area.children.sort((a, b) => a.rank - b.rank),
      };
    });
  }
}
